<ngb-carousel id="main-slider" *ngIf="slides">
  <ng-template ngbSlide *ngFor="let slide of slides">
    <img src="{{slide.image}}" [attr.alt]="slide.title" />
    <div class="carousel-caption">
      <h3>{{slide.title}}</h3>
      <div [innerHTML]="slide.short"></div>
      <p *ngIf="slide.routerLink"><a class="btn btn-outline-light" [routerLink]="slide.routerLink">Tovább</a></p>
      <p *ngIf="!slide.routerLink && slide.forward"><a class="btn btn-outline-light" href="{{slide.forward}}">Tovább</a></p>
    </div>
  </ng-template>
</ngb-carousel>

<div class="row">
  <section class="col-md-6 col-xl-7">
    <h3>Aktuális hírek</h3>

    <p *ngIf="!articles"><span class="fa fa-spinner fa-spin"></span></p>
    <p *ngIf="articles && !articles.length">Nincsenek aktuális hírek.</p>

    <article *ngFor="let article of articles">
      <h4>{{article.title}}</h4>
      <h6>{{article.subtitle}}</h6>
      <p>{{article.short}}</p>
      <p><a [routerLink]="['/tartalmak/hirek', article.id]" class="btn btn-outline-primary">Bővebben <i
          class="fa fa-chevron-right"></i></a></p>
    </article>

    <p>
      <a [routerLink]="['/tartalmak/hirek']"
         class="btn btn-outline-primary"
      >Továbbiak</a>
    </p>
  </section>

  <!--<section class="col-md-6 col-xl-4">-->
    <!--<h3>Közelgő események</h3>-->

    <!--<article *ngFor="let event of events" class="event">-->
      <!--<span class="date">-->
        <!--<span class="month">{{event.month}}</span>-->
        <!--<span class="day">{{event.day}}</span>-->
      <!--</span>-->
      <!--<div class="info">-->
        <!--<h5 class="title">{{event.title}}</h5>-->
        <!--<span class="location">Helyszín: {{event.location}}</span>-->
        <!--<span class="time">Időpont: {{event.time}}</span>-->
      <!--</div>-->
    <!--</article>-->
  <!--</section>-->

  <section class="col-md-6 col-xl-5">
    <h3>Ajánlott oldalak</h3>

    <ngb-carousel id="recommended-pages">
      <ng-template ngbSlide *ngFor="let r of recommended">
        <img src="{{r.image}}" [attr.alt]="r.title">
        <div class="carousel-caption">
          <h3>{{r.title}}</h3>
          <p>{{r.short}}</p>
          <p *ngIf="r.forward"><a class="btn btn-outline-primary" href="{{r.forward}}">Tovább</a></p>
          <p *ngIf="r.route"><a class="btn btn-outline-primary" [routerLink]="r.route">Tovább</a></p>
        </div>
      </ng-template>
    </ngb-carousel>
  </section>
</div>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/home/home.component.html